@if (selectedRecords.length) {
    <div class="flex items-center w-initial h-10 mt-4 mx-6 px-4 rounded-lg bg-darkThemePrimaryDark">
        <div
            *transloco="let tTable; read: 'table'"
            class="flex items-center justify-between w-full"
        >
            <div class="flex items-center">
                <app-tb-checkbox
                    (valueChange)="clearAllSelected()"
                    [value]="true"
                    class="mr-2 h-5 flex"
                ></app-tb-checkbox>
                <span class="text-inverted body-1"
                    >{{ tTable('actions_panel_count', { count: selectedRecords.length }) }}
                </span>
            </div>
            <div class="flex items-center">
                <div class="sm:inline-flex xsm:hidden">
                    <ng-container
                        *ngTemplateOutlet="actionButtons; context: { dark: true }"
                    ></ng-container>
                </div>
                <!-- incorrect bg color -->
                <app-tb-menu #xsmMenu [template]="xsmActionButtons">
                    <app-tb-button
                        trigger
                        [appearance]="'icon'"
                        [dark]="true"
                        [icon]="'more_vert'"
                        class="sm:hidden h-6"
                    ></app-tb-button>
                </app-tb-menu>
                <app-tb-button
                    [appearance]="'icon'"
                    [dark]="true"
                    [icon]="'close'"
                    (click)="clearAllSelected()"
                    aria-label="Close"
                    class="h-5 ml-6"
                ></app-tb-button>
            </div>

            <ng-template #actionButtons>
                <app-record-action-buttons
                    [selectedRecords]="selectedRecords"
                    [dark]="true"
                ></app-record-action-buttons>
            </ng-template>

            <ng-template
                #xsmActionButtons
                let-containerLayout="containerLayout"
                let-close="closeFn"
            >
                <app-modal-layout [containerLayout]="containerLayout" (closeModal)="close()">
                    <ng-container title>
                        {{ tTable('action_panel_bottom_sheet_title') }}
                    </ng-container>
                    <app-record-action-buttons
                        [selectedRecords]="selectedRecords"
                    ></app-record-action-buttons>
                </app-modal-layout>
            </ng-template>
        </div>
    </div>
}
